import React from 'react'

import Cover from './Cover'
import MetodoMosler from './MetodoMosler'
import Separator from '../../../../../components/helpers/Separator'

const CalculoDeRiscoContent = ({ headerValues, diagSegValues, moslerValues }) => {
  headerValues = {
    tipo: 'CHECKLIST - ANÁLISE DE RISCO',
    titulo: 'Método de Mosler',
    ...headerValues
  }

  return (
    <>
      <Cover headerValues={headerValues} />
      <Separator weight={10} />
      <MetodoMosler headerValues={headerValues} moslerValues={moslerValues} diagSegValues={diagSegValues} />
    </>
  )
}

export default CalculoDeRiscoContent
